import { MaskText } from "@/components/Reveal";

// Consistent inner-page header with generous top spacing (clears fixed header)
export const PageHead = ({ eyebrow, titleLines = [], intro }) => (
  <section className="edge pt-36 pb-16 md:pt-48 md:pb-24" data-testid="page-head">
    <span className="eyebrow block">{eyebrow}</span>
    <h1 className="mt-6 text-5xl font-light leading-[0.95] tracking-editorial md:text-7xl lg:text-8xl">
      <MaskText lines={titleLines} delay={0.1} />
    </h1>
    {intro && (
      <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">
        {intro}
      </p>
    )}
  </section>
);
